<template>
  <div class="top-fixed">
    <div class="top-warp">
      <div class="mobile-mask" v-show="menuShow"></div>
      <div class="mobile-menu" :class="{show: menuShow}">
        <div class="menu-header">
          <h2 class="logo"><img src="../assets/images/tumile-logo.png" alt="Tumile"></h2>
          <h5 class="menu-close" @click="menuShow = false"><img src="../assets/images/close.png" alt="close"></h5>
        </div>
        <ul class="nav-bar">
          <li v-for="(item, index) in menuData" @click="switchMenu(item.path)" :class="{active: item.path === currentMeun}" :key="item + '' + index">{{item.name}}</li>
        </ul>
      </div>
      <div class="header-bar">
        <h1 class="logo-text" @click="showMenu">Safety Center</h1>
        <h2 class="logo"><img src="../assets/images/tumile-logo.png" alt="Tumile"></h2>
        <ul class="icon-list">
          <li><a href="https://tumilechat.zendesk.com/hc/en-us/requests/new?ticket_form_id=1500000268822" target="_blank"><img src="../assets/images/mail.png" alt=""></a></li>
          <!-- <li><a href=""><img src="../assets/images/facebook.png" alt=""></a></li>
          <li><a href=""><img src="../assets/images/tw.png" alt=""></a></li> -->
        </ul>
      </div>
      <ul class="nav-bar">
        <li v-for="(item, index) in menuData" @click="switchMenu(item.path)" :class="{active: item.path === currentMeun}" :key="item + '' + index">{{item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { triggerService } from '../utils/statisticalTool'
export default {
  name: 'top',
  data () {
    return {
      currentMeun: '',
      menuShow: false,
      menuData: [
        {
          name: 'About Our Safety Center',
          path: '/'
        },
        {
          name: 'Community Guidelines',
          path: '/community-guidelines'
        },
        {
          name: 'Safety Tips &Tools',
          path: '/safety-tips'
        },
        {
          name: 'Child Safety Policy',
          path: '/child-safety-policy'
        },
        {
          name: 'Submit a Report',
          path: '/make-report'
        },
        {
          name: 'Law Enforcement Portal',
          path: '/law-enforcement'
        },
        {
          name: 'FAQs',
          path: '/faqs'
        }
      ],
      clientTraceId: ''
    }
  },
  created () {
    this.currentMeun = window.location.hash.substring(1)
  },
  mounted () {
    this.clientTraceId = localStorage.getItem('clientTraceId') || ''
    triggerService({ eventId: '104-1-1-1', freeName1: this.clientTraceId })
  },
  watch: {
    '$route.path' (v) {
      console.log(v)
      this.currentMeun = v
    }
  },
  methods: {
    switchMenu (path) {
      if (path === this.currentMeun) return
      this.currentMeun = path
      this.$router.push({ path })
      this.menuShow = false
      let freeName = path.replace('/', '') || 'safety-center'
      triggerService({ eventId: '104-1-1-2', freeName1: this.clientTraceId, freeName2: freeName })
    },
    showMenu () {
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (w < 750) {
        this.menuShow = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .top-fixed {
    min-height: 120px;
  }
  .top-warp {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: #ffffff;
    width: 100%;
    height: 120px;
    box-shadow:0px 8px 7px 0px rgba(0,0,0,0.03);
    .header-bar {
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
    }
    .logo-text {
      text-align: left;
      font-weight: bold;
      font-size: 24px;
      color: #333;
    }
    .logo {
      width: 94px;
      height: 24px;
      img {
        max-width: 100%;
      }
    }
    .icon-list {
      display: flex;
      li {
        width: 24px;
        height: 24px;
        margin-left: 20px;
        img {
          max-width: 100%;
        }
      }
    }
    .nav-bar {
      display: flex;
      max-width: 1440px;
      margin: 35px auto 0 auto;
      justify-content: space-between;
      li {
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        color: #333;
        position: relative;
        &.active::before {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -10px;
          width: 38px;
          height: 3px;
          background-color: $primary;
          transform: translateX(-50%)
        }
      }
    }
    .mobile-menu {
      display: none;
    }
    .mobile-mask {
      display: none;
    }
  }
}

@media (max-width: 750px) {
  .top-fixed {
    min-height: 56px;
  }
  .top-warp {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: #ffffff;
    width: 100%;
    height: 56px;
    box-shadow:0px 4px 4px 0px rgba(0,0,0,0.03);
    .header-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 17px 25px 0 25px;
    }
    .logo-text {
      text-align: left;
      font-weight: bold;
      font-size: 16px;
      color: #333;
      position: relative;
      padding-left: 30px;
    }
    .logo-text::before {
      content: '';
      position: absolute;
      top: 2px;
      left: 0;
      width: 22px;
      height: 16px;
      background: url('../assets/images/menu-icon.png') no-repeat;
    }
    .logo {
      width: 64px;
      img {
        max-width: 100%;
      }
    }
    .icon-list {
      display: none;
      li {
        width: 24px;
        height: 24px;
        margin-left: 20px;
        img {
          max-width: 100%;
        }
      }
    }
    .nav-bar {
      display: none;
    }
    .mobile-mask {
      width: 100%;
      height: 100vh;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
    }
    .mobile-menu {
      position: absolute;
      left: -100%;
      top: 0;
      height: 100vh;
      width: 80%;
      z-index: 998;
      background-color: #ffffff;
      transition: all .3s linear;
      &.show {
        left: 0;
      }
      .menu-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 25px;
        .logo {
          width: 64px;
          img {
            max-width: 100%;
          }
        }
      }
      .nav-bar {
        display: block;
        li {
          text-align: left;
          height: 52px;
          cursor: pointer;
          font-size: 16px;
          color: #333;
          border-bottom: solid 1px #F4F4F4;
          display: flex;
          align-items: center;
          padding: 0 25px;
          &.active {
            background-color: #F4F4F4
          }
          &:last-child {
            border: none;
          }
        }
      }
    }
  }
}
</style>
